import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { DashboardApiModel } from './models/dashboard-api.model';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class DashboardApi {

    constructor(private neptuneApi: NeptuneApi) {}

    public getDashboard(): Observable<DashboardApiModel> {
        return this.neptuneApi.api<DashboardApiModel>(
            '/dashboards',
            null,
            HttpVerbsEnum.GET,
        );
    }

    /**
     * Helper method: If the dashboard has an ID, call update, else, create
     *
     * @param dashboard
     *
     * @returns Observable<number>
     */
    public saveDashboard(dashboard: DashboardApiModel): Observable<number> {
        if (dashboard.id) {
            return this.updateDashboard(dashboard);
        } else {
            return this.createDashboard(dashboard);
        }
    }

    public createDashboard(dashboard: DashboardApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            '/dashboards',
            dashboard,
            HttpVerbsEnum.POST
        );
    }

    public updateDashboard(dashboard: DashboardApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            // `/dashboards/${dashboard.id}`,
            '/dashboards',
            dashboard,
            HttpVerbsEnum.PUT
        );
    }

    public getFeeds(feed: string): Observable<DashboardApiModel> {
        // TODO: add feed to url
        return this.neptuneApi.api<DashboardApiModel>(
            `/dashboard-feeds/${feed}`,
            null,
            HttpVerbsEnum.GET,
            null,
            'text'
        );
    }
}
